import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedoRegular = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 512 480",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.675659 289.168C0.675659 175.05 96.2884 99.7104 190.134 99.7104H331.931C345.579 99.7104 356.642 110.774 356.642 124.422C356.642 138.07 345.579 149.134 331.931 149.134H190.134C120.221 149.134 50.0995 205.592 50.0995 289.168C50.0995 372.745 120.221 429.203 190.134 429.203H321.931C335.579 429.203 346.642 440.267 346.642 453.915C346.642 467.563 335.579 478.626 321.931 478.626H190.134C96.2884 478.626 0.675659 403.287 0.675659 289.168Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M343.82 3.4716C352.192 -0.714403 362.211 0.188964 369.699 5.80507L501.496 104.653C507.718 109.32 511.381 116.644 511.381 124.422C511.381 132.201 507.718 139.525 501.496 144.192L369.699 243.039C362.211 248.656 352.192 249.559 343.82 245.373C335.448 241.187 330.16 232.63 330.16 223.27V25.5746C330.16 16.2144 335.448 7.6576 343.82 3.4716Z"
	})]
});
export default SvgRedoRegular;
